import {
  DefaultEntityFilters,
  EntityAutocompletePicker,
  EntityFilter,
} from '@backstage/plugin-catalog-react';

/** The only part of an entity this filter reads (avoids a direct dependency on catalog-model). */
type HasSystem = { spec?: { system?: unknown } };

/** `spec.system` is a bare name in this catalog but may also be a full ref; compare on the name. */
const systemName = (value: unknown): string =>
  String(value ?? '').replace(/^system:/, '').replace(/^default\//, '');

/** Narrows the entity list to the chosen Systems (a Component's, API's or Resource's `spec.system`). */
export class EntitySystemFilter implements EntityFilter {
  constructor(readonly values: string[]) {}

  getCatalogFilters() {
    return { 'spec.system': this.values };
  }

  filterEntity(entity: HasSystem) {
    return this.values.map(systemName).includes(systemName(entity.spec?.system));
  }

  toQueryValue() {
    return this.values;
  }
}

type SystemFilters = DefaultEntityFilters & { system?: EntitySystemFilter };

/** The "System" dropdown in the catalog's filter column, offering only systems that have entities. */
export function SystemPicker() {
  return (
    <EntityAutocompletePicker<SystemFilters, 'system'>
      label="System"
      name="system"
      path="spec.system"
      Filter={EntitySystemFilter}
      filtersForAvailableValues={['kind']}
    />
  );
}
